// lazy-embed.js
(function () {
  // Generic lazy for iframes using data-src
  const lazyIframes = [].slice.call(document.querySelectorAll('iframe[data-src]'));
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach(e => {
        if (!e.isIntersecting) return;
        const el = e.target;
        el.src = el.getAttribute('data-src');
        el.removeAttribute('data-src');
        el.loading = 'lazy';
        el.decoding = 'async';
        obs.unobserve(el);
      });
    }, { rootMargin: '400px' });
    lazyIframes.forEach(el => io.observe(el));
  } else {
    // Fallback: charge après onload
    window.addEventListener('load', () => {
      lazyIframes.forEach(el => {
        el.src = el.getAttribute('data-src');
        el.removeAttribute('data-src');
      });
    });
  }

  // Lite YouTube (placeholder → iframe au clic)
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-yt]');
    if (!btn) return;
    const id = btn.getAttribute('data-yt');
    const parent = btn.closest('.lite-yt');
    if (!id || !parent) return;
    parent.innerHTML =
      `<iframe title="YouTube video player" loading="lazy" decoding="async"
         allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
         allowfullscreen
         src="https://www.youtube.com/embed/${id}?rel=0&autoplay=1"></iframe>`;
  }, { passive: true });
})();
